module.exports = __webpack_public_path__ + "img/luggage.028d624.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/luggage.png
// module id = 1094
// module chunks = 0